import { css } from '@emotion/css'

export const styles = {
  TopRowCss: css`
    display: flex;

    align-items: center;
    max-width: 100%;
    overflow: hidden;
  `,
  nameContainerCss: css`
    flex-shrink: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
  nameContainerActiveInPanelCss: css`
    font-weight: 700;
  `,

  bugTrackersContainerCss: css`
    flex-grow: 0;
    margin-left: 4px;
  `,

  tagsCss: css`
    display: flex;
    margin-left: 4px;
    overflow: hidden;
    margin-right: 8px;
    width: 100%;
  `
}
